"use client";

import type { ReactNode } from "react";
import { usePathname } from "next/navigation";

import { isSensitiveBrowserPath } from "@/lib/sensitive-route-policy";

export default function SensitiveTelemetryGate({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  if (isSensitiveBrowserPath(pathname)) return null;
  return <>{children}</>;
}
